import { View } from 'lcc-state/interfaces';

// import { Messages, Bundle } from '@dojo/framework/i18n/i18n';
// import { LocalizedMessages } from '@dojo/framework/core/mixins/I18n';
// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DNode, WNodeFactory, WidgetProperties } from '@dojo/framework/core/interfaces';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { lccstate } from '@holmescorp/lcc-state';
import { scroll } from '@holmescorp/middleware';

import css from '../css/pagegroup.m.css';

export interface LPPageGroupProperties {
	classes?: string[];
	name?: string;
	element?: string;
	kids?: LPKidType[];
}

export interface LPKidType {
	widget: string;
	name?: string;
	element?: string;
	kids?: LPKidType[] | string[];
}

interface LPPageGroupCache {
	scrolled: boolean;
}

const icache = createICacheMiddleware<LPPageGroupCache>();
const factory = create({ icache, theme, lccstate, scroll }).properties<LPPageGroupProperties>();

export const LPPageGroup = factory(({ properties, middleware: { icache, theme, lccstate, scroll } }) => {
	const render_kids = (kids: LPKidType[]): DNode[] => {
		return kids.map((kid) => {
			const { widget } = kid;
			const params: Partial<LPKidType> = { ...kid };
			delete params['widget'];
			return w(widget, { ...params } as any as WidgetProperties);
		});
	};

	const render_view = (view: View): DNode[] => {
		return [w(view.widget, { ...view.params })];
	};

	const { classes = [], name = 'lppagegroupdefault', element = 'div', kids = [] } = properties();
	const view: View = lccstate.get(lccstate.path('view'));
	const themeCss = theme.classes(css);

	// scroll the new content into view, but only when rendering a `view`
	if (view && view.widget && !icache.get('scrolled')) {
		scroll.scrollIntoView('lppagegroup-wrapper');
		icache.set('scrolled', true);
	} else if (!view) {
		// reset scroll status when loading something other than a `view`
		icache.set('scrolled', false, false);
	}

	return v('div', { key: 'lppagegroup-wrapper' }, [
		v(
			element,
			{ classes: [themeCss.root, ...classes], key: name, xqa: `lppagegroup ${name}` },
			view && view.widget ? render_view(view) : render_kids(kids)
		)
	]);
});

export default LPPageGroup;
